import { ODSPriorityGroups } from "../../interfaces/Indicator";

const OdsChips = ({ ods }: { ods: ODSPriorityGroups[] }) => {
    if (!ods || ods.length === 0) return null;

    return (
        <div className="flex gap-2 items-center flex-wrap">
            <span className="text-gray-40 text-bmedium">ODS:</span>
            {ods.map((o) => (
                <div
                    style={{ backgroundColor: o.color }}
                    className="text-center flex justify-center items-center text-primary-100 rounded-xsm text-lmedium w-[1.25rem] h-[1.25rem]"
                    key={o.id}
                    title={o.nombre}
                >
                    {o.numero}
                </div>
            ))}
        </div>
    );
};

export default OdsChips